import { create, destroy, getAll } from "../api/dealStageAsset";

export const getDealStageAssets = (dealID) => ({
  type: "DEAL_STAGE_ASSETS_GET",
  meta: { dealID },
  payload: getAll(dealID),
});

export const createDealStageAsset = (dealStageAsset) => ({
  type: "DEAL_STAGE_ASSETS_CREATE",
  payload: create(dealStageAsset),
});

export const deleteDealStageAsset = (dealStageAsset) => ({
  type: "DEAL_STAGE_ASSETS_DELETE",
  meta: { dealStageAssetID: dealStageAsset.id },
  payload: destroy(dealStageAsset.id),
});
